module.exports = __webpack_public_path__ + "static/media/supplychain.0003fa12.png";